module.exports = __webpack_public_path__ + "static/undraw_dashboard_nklg-5e09ece6910218f68b747dbdb39ec4ac.svg";